export default [
    {
      title: "Privilege",
      customIcon: "PrivilegeSVG",
      children: [
        {
            title: 'Privilege',
            route: "custom-privilege-list",
            path: "/custom-privilege/list",
        },
        {
            title: "Category",
            route: "custom-privilege-category-list",
            path: "/custom-privilege/category-list",
        },
        {
            title: 'Sub Category',
            route: "custom-privilege-subcategory-list",
            path: "/custom-privilege/subcategory-list",
        },
        {
            title: 'Group Category',
            route: "custom-privilege-group-category-list",
            path: "/custom-privilege/group-category-list",
        },
      ],
    },
];